import { Link } from 'react-router-dom';
import { Text, Title2, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';
import { ROSTER_PATH, sectionOn } from '@/lib/sections';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingHorizontalXXL,
  },
});

export function NotFoundPage() {
  const styles = useStyles();
  // With the Dashboard switched off (#610) the way back is the Roster, and the link says so.
  const dashboard = sectionOn('dashboard');
  return (
    <div className={styles.page}>
      <Title2>Page not found</Title2>
      <Text>That address does not exist.</Text>
      <Link to={dashboard ? '/app' : ROSTER_PATH}>
        <Text>{dashboard ? 'Go to the dashboard' : 'Go to the Roster'}</Text>
      </Link>
    </div>
  );
}
